<!-- Brand Logo -->

<div class="d-flex align-items-center gap-2">
    <ng-container *ngIf="dashboardLogoUrl">
        <a [routerLink]="loginInfo.role == 'Platform Admin' ? '/platformAdmin' : '/dashboard/ghgEmission'"
            class="brand-link">
            <!-- <img *ngIf="updatedtheme === 'dark'" class="pl-4 et_logo_1" src="assets/img/Carbontek.png" alt="Ekobon Logo"
                height="33"/>
        
        
            <img *ngIf="updatedtheme !== 'dark'" class="pl-4 et_logo_1" src="assets/img/Carbontek.png" alt="Ekobon Logo"
                height="33"/> -->

            <img *ngIf="updatedtheme === 'dark'" class="pl-4 et_logo_1" [src]="dashboardLogoUrl" alt="Ekobon Logo"
                height="33" />


            <img *ngIf="updatedtheme !== 'dark'" class="pl-4 et_logo_1" [src]="dashboardLogoUrl" alt="Ekobon Logo"
                height="33" />
        </a>

    </ng-container>
    <div class="gap-2 text-dark ct_open_bar" (click)="onToggleMenuSidebar()">
        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512">
            <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
            <path
                d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
        </svg>
    </div>
</div>


<!-- Sidebar -->
<div class="sidebar">

    <!-- Sidebar Menu -->
    <nav class="mt-2">

        <div>
            <ul *ngIf="IsPAdmin" class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu"
                data-accordion="false" [ngClass]="updatedtheme === 'dark'">
                <div *ngFor="let item of menu">

                    <p *ngIf="item.head !== undefined" [ngClass]="
                            this.updatedtheme === 'dark'
                                ? 'headtextD'
                                : 'headtextL'
                        ">
                        {{ item.head }}
                    </p>
                    <app-menu-item [menuItem]="item"></app-menu-item>
                </div>
            </ul>
            <ul *ngIf="!IsPAdmin" class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu"
                data-accordion="false">
                <div *ngFor="let item of menu; let i = index" class="ct_custom_dropdown"
                    [ngClass]="{'ct_active': activeDropdownIndexes.includes(i)}">
                    <p (click)="toggleDropdown(i)" class="my-0" *ngIf="item.head !== undefined" [ngClass]="
                            this.updatedtheme === 'dark'
                                ? 'headtextD'
                                : 'headtextL'
                        ">
                        {{ item.head }} <i class="fa-solid fa-angle-down"></i>
                    </p>
                    <div class="ct_custom_dropdown_items">
                        <ng-container *ngFor="let item2 of item.children">
                            <app-menu-item [menuItem]="item2"></app-menu-item>
                        </ng-container>
                    </div>
                </div>
            </ul>
        </div>

    </nav>
</div>